import type { ProductRoadmapItem, ProductVoteCampaign } from '../../../types/ProductUpdates'

/** Roadmap items tied to an open vote campaign (not shipped, deadline in the future). */
export function roadmapItemsWithOpenVoteCampaign(
  roadmap: ProductRoadmapItem[],
  voteCampaigns: ProductVoteCampaign[] | undefined,
  nowMs: number
): Set<string> {
  const camps = new Map((voteCampaigns ?? []).map((c) => [c.id, c]))
  const open = new Set<string>()
  for (const item of roadmap) {
    if (!item.voteCampaignId || item.status === 'shipped') continue
    const c = camps.get(item.voteCampaignId)
    if (!c) continue
    const end = Date.parse(c.closesAt)
    if (Number.isFinite(end) && nowMs < end) open.add(item.id)
  }
  return open
}

/**
 * Within each vote campaign (open or closed), item ids that share the highest vote count.
 */
export function roadmapVoteLeadingItemIds(
  roadmap: ProductRoadmapItem[],
  voteCampaigns: ProductVoteCampaign[] | undefined,
  countsByItemId: Record<string, number>
): Set<string> {
  const camps = new Map((voteCampaigns ?? []).map((c) => [c.id, c]))
  const byCampaign = new Map<string, string[]>()

  for (const item of roadmap) {
    if (!item.voteCampaignId || item.status === 'shipped') continue
    if (!camps.has(item.voteCampaignId)) continue
    const arr = byCampaign.get(item.voteCampaignId) ?? []
    arr.push(item.id)
    byCampaign.set(item.voteCampaignId, arr)
  }

  const leaders = new Set<string>()
  for (const ids of byCampaign.values()) {
    let max = -1
    for (const id of ids) {
      const n = countsByItemId[id] ?? 0
      if (n > max) max = n
    }
    if (max <= 0) continue
    for (const id of ids) {
      if ((countsByItemId[id] ?? 0) === max) leaders.add(id)
    }
  }
  return leaders
}

export function formatVoteDeadline(closesAtIso: string, locale?: string): string {
  const d = Date.parse(closesAtIso)
  if (!Number.isFinite(d)) return closesAtIso
  return new Date(d).toLocaleString(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}
